<template>
  <div class="question-container">
    <div v-if="mode == 0">
      <div class="row">
        <div v-if="showTitle" class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question && question.isSkippable">Optional</span>
        </div>

        <div v-if="preventPIIAccessFromRoles" :class="showTitle ? 'col-md-7' : 'col-md-12'">
          <template v-if="answer && answer.answerText">
            <div v-for="(audio, index) in parsedAns" :key="index">
              <div v-if="audio.isTextEnable">
                <p>{{ audio.text }}</p>
              </div>
              <div class="row mb-15" v-else>
                <div id="songPlayPause" class="col-md-1 p-0" @click="playPause(`${answer.questionId}-${revisedAudioName(audio.name)}-song`)">
                  <img :src="isPlaying.indexOf(`${answer.questionId}-${revisedAudioName(audio.name)}-song`) >= 0 ? audioImgs[1] : audioImgs[0]" alt="" />
                </div>
                <div class="col-md-10 ml-10">
                  <p class="m-0">{{ audio.name }} - {{ audio.time }}</p>
                  <audio :id="`${answer.questionId}-${revisedAudioName(audio.name)}-song`" @timeupdate="updateTime(`${answer.questionId}-${revisedAudioName(audio.name)}`)">
                    <source :src="audio.presignedURL" type="audio/mp3" />
                    Your browser does not support the audio tag.
                  </audio>
                  <div class="d-flex pt-5">
                    <div :id="`${answer.questionId}-${revisedAudioName(audio.name)}-audioSlider`" class="audio-slider" @click="setSongPosition(this, event)">
                      <div :id="`${answer.questionId}-${revisedAudioName(audio.name)}-trackProgress`" class="track-progress"></div>
                    </div>
                    <div :id="`${answer.questionId}-${revisedAudioName(audio.name)}-audioTime`" class="pl-5 audio-time">
                      0:00
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div v-else>
          <template v-if="answer && answer.answerText">
            <div>
              <p v-for="(fileName, idx) in answer.answerText.split(',')" :key="idx">
                {{ fileName }}
              </p>
              <p>{{ new Date(answer.startTime) | formatGMTDate }}</p>
            </div>
          </template>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question && question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question && question.isSkippable" :class="isQuestionSkipped() ? 'disable-question' : ''">Optional</span>
          <span v-if="isQuestionSkipped()" class="skipped-question-box ml-15 d-inline-box pt-2">
            Skipped
          </span>
        </div>

        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="preventPIIAccessFromRoles">
          <template v-if="answer">
            <div v-for="(audio, index) in parsedAns" :key="index">
              <div v-if="audio.isTextEnable">
                <p>{{ audio.text }}</p>
              </div>
              <div class="row mb-15" v-else>
                <div id="songPlayPause" class="col-md-1 p-0" @click="playPause(`${answer.questionId}-${revisedAudioName(audio.name)}-edit-song`)">
                  <img :src="isPlaying.indexOf(`${answer.questionId}-${revisedAudioName(audio.name)}-edit-song`) >= 0 ? audioImgs[1] : audioImgs[0]" alt="" />
                </div>
                <div class="col-md-10 ml-10">
                  <p class="m-0">{{ audio.name }} - {{ audio.time }}</p>
                  <audio :id="`${answer.questionId}-${revisedAudioName(audio.name)}-edit-song`" @timeupdate="updateTime(`${answer.questionId}-${revisedAudioName(audio.name)}-edit`)">
                    <source :src="audio.presignedURL" type="audio/mp3" />
                    Your browser does not support the audio tag.
                  </audio>
                  <div class="d-flex pt-5">
                    <div :id="`${answer.questionId}-${revisedAudioName(audio.name)}-edit-audioSlider`" class="audio-slider" @click="setSongPosition(this, event)">
                      <div :id="`${answer.questionId}-${revisedAudioName(audio.name)}-edit-trackProgress`" class="track-progress"></div>
                    </div>
                    <div :id="`${answer.questionId}-${revisedAudioName(audio.name)}-edit-audioTime`" class="pl-5 audio-time">
                      0:00
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div v-else>
          <template v-if="answer && answer.answerText">
            <div>
              <p v-for="(fileName, idx) in answer.answerText.split(',')" :key="idx">
                {{ fileName }}
              </p>
              <p>{{ new Date(answer.startTime) | formatGMTDate }}</p>
            </div>
          </template>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question && question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="preventPIIAccessFromRoles && showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question && question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <div v-if="preventPIIAccessFromRoles">
              <template v-if="answer && answer.answer_text">
                <div class="col-md-12 pl-30">
                  <div v-for="(audio, index) in parsedAns" :key="index">
                    <div v-if="audio.isTextEnable">
                      <p>{{ audio.text }}</p>
                    </div>
                    <div class="row mb-15" v-else>
                      <div id="songPlayPause" class="col-md-1 p-0" @click="playPause(`${answer.question_id}-${revisedAudioName(audio.name)}-history-song`)">
                        <img :src="isPlaying.indexOf(`${answer.question_id}-${revisedAudioName(audio.name)}-history-song`) >= 0 ? audioImgs[1] : audioImgs[0]" alt="" />
                      </div>
                      <div class="col-md-10 ml-10">
                        <p class="m-0">{{ audio.name }} - {{ audio.time }}</p>
                        <audio :id="`${answer.question_id}-${revisedAudioName(audio.name)}-history-song`" @timeupdate="updateTime(`${answer.question_id}-${revisedAudioName(audio.name)}-history`)">
                          <source :src="audio.presignedURL" type="audio/mp3" />
                          Your browser does not support the audio tag.
                        </audio>
                        <div class="d-flex pt-5">
                          <div :id="`${answer.question_id}-${revisedAudioName(audio.name)}-history-audioSlider`" class="audio-slider" @click="setSongPosition(this, event)">
                            <div :id="`${answer.question_id}-${revisedAudioName(audio.name)}-history-trackProgress`" class="track-progress"></div>
                          </div>
                          <div :id="`${answer.question_id}-${revisedAudioName(audio.name)}-history-audioTime`" class="pl-5 audio-time">
                            0:00
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="d-inline-block ml-25 pt-10" v-if="showScore && answer.score != null">
                    <label>Score</label>
                    <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                      {{ answer.score }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="question && question.isSkippable">
                <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                  <label class="fs-12">Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ question.skipScore || 0 }}
                  </div>
                </div>
              </template>
            </div>
            <div v-else>
              <template v-if="answer && answer.answer_text">
                <div>
                  <p v-for="(fileName, idx) in answer.answer_text.split(',')" :key="idx">
                    {{ fileName }}
                  </p>
                  <p>{{ new Date(answer.start_time) | formatGMTDate }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1"></div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import { BSTAT, CRA, DM, HOME_HEALTH, PHV, PI, QUALITY, STUDY_ADMIN, STUDY_MANAGER, SYSTEM_ADMIN, CraUB, SUPPORT } from "@/constants/authRoles";
export default {
  name: "AudioRecordingResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      audioImgs: ["static/img/activity-configurator/audio-recording-media-play.png", "static/img/activity-configurator/audio-recording-media-pause.png"],
      activeSong: {},
      isPlaying: []
    };
  },
  props: {
    mode: Number,
    answer: Object,
    question: Object,
    usage: Object,
    surveyData: Object,
    stepIndex: Number,
    selectedLanguageCulture: String,
    showTitle: {
      type: Boolean,
      default: true
    },
    modelPreview: {
      type: Boolean,
      default: false
    },
    activityType: String
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    preventPIIAccessFromRoles() {
      const roles = this.canSysAdminAccess || this.canStudyAdminAccess || this.canStudyManagerAccess || this.canCraAccess || this.canDmAccess || this.canQualityAccess || this.canBioStatisticsAccess || this.canPharmacovigilanceAccess || this.canCraUBAccess || this.canSupportAccess;
      return !roles;
    },
    parsedAns() {
      if (this.answer && this.answer[this.JsonFieldToDisplay()]) {
        return JSON.parse(this.answer[this.JsonFieldToDisplay()]);
      }
      return [];
    }
  },
  watch: {
    mode() {
      this.isPlaying.length = 0;
      this.resetAudios();
    }
  },
  methods: {
    updateTime(answerId) {
      const currentSongId = `${answerId}-song`;
      if (typeof this.activeSong[currentSongId] !== "undefined") {
        const currentSeconds = (Math.floor(this.activeSong[currentSongId].currentTime % 60) < 10 ? "0" : "") + Math.floor(this.activeSong[currentSongId].currentTime % 60);
        const currentMinutes = Math.floor(this.activeSong[currentSongId].currentTime / 60);
        //Sets the current song location compared to the song duration.
        document.getElementById(`${answerId}-audioTime`).innerHTML = currentMinutes + ":" + currentSeconds;
        //Fills out the slider with the appropriate position.
        const percentageOfSong = this.activeSong[currentSongId].currentTime / this.activeSong[currentSongId].duration;
        const percentageOfSlider = document.getElementById(`${answerId}-audioSlider`).offsetWidth * percentageOfSong;
        //Updates the track progress div.
        document.getElementById(`${answerId}-trackProgress`).style.width = Math.round(percentageOfSlider) + "px";
        //Resetting once the audio playing is completed
        if (this.activeSong[currentSongId].currentTime == this.activeSong[currentSongId].duration) {
          const playIndex = this.isPlaying.indexOf(`${answerId}-song`);
          if (playIndex >= 0) {
            this.isPlaying.splice(playIndex, 1);
          }
          document.getElementById(`${answerId}-trackProgress`).style.width = 0 + "px";
          document.getElementById(`${answerId}-audioTime`).innerHTML = "0:00";
        }
      } else {
        document.getElementById(`${answerId}-trackProgress`).style.width = 0 + "px";
        document.getElementById(`${answerId}-audioTime`).innerHTML = "0:00";
      }
    },
    playPause(song) {
      //Sets the active song since one of the functions could be play.
      if (this.modelPreview) {
        return;
      }

      this.activeSong[song] = document.getElementById(song);
      const songIndex = this.isPlaying.indexOf(song);
      if (this.activeSong[song].paused) {
        if (songIndex < 0) {
          this.isPlaying.push(song);
        }
        this.activeSong[song].play();
      } else {
        this.isPlaying.splice(songIndex, 1);
        this.activeSong[song].pause();
      }
    },
    setSongPosition(obj, e) {
      //Gets the offset from the left so it gets the exact location.
      const audioSliderWidth = obj.offsetWidth;
      const evtobj = window.event ? event : e;
      const clickLocation = evtobj.layerX - obj.offsetLeft;
      const percentage = clickLocation / audioSliderWidth;
      //Sets the song location with the percentage.
      setLocation(percentage);
    },
    revisedAudioName(audioName) {
      const newStr = audioName.replace(" ", "-");
      return newStr.toLowerCase();
    },
    resetAudios() {
      for (const audio in this.activeSong) {
        this.activeSong[audio].load();
      }
      this.activeSong = {};
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}
.audio-slider {
  width: 260px;
  height: 13px;
  border-radius: 30px;
  background-color: #c4c4c4;
}
/*Track progress bar*/
.track-progress {
  width: 0px;
  height: 13px;
  border-radius: 30px;
  background-color: #4c8ce4;
}
.audio-time {
  line-height: 1;
  font-size: 14px;
  font-weight: 500;
  color: #4c8ce4;
}
</style>
